import React from "react";

const BS5_StudyPlan = () => {
  return (
    <div className="container mt-4">
      <h2>BS5_StudyPlan Component</h2>
      <p>This is the BS5_StudyPlan component for Bootstrap 5 tutorial.</p>
    </div>
  );
};

export default BS5_StudyPlan;
